/* eslint-disable no-shadow */
/*  Google maps links coordiantes sometime comes after 
    @ sign the other times come after q query
    so here is two regex cases to cover
*/
const firstRegex = /@([-\d.]+),([-\d.]+)/;
const secondRegex = /q=([-+]?[0-9]*\.?[0-9]+),([-+]?[0-9]*\.?[0-9]+)/;

const expandShortUrl = async (url) => {
    const linkPreviewApiKey = "e3c5bd4d84d6164251d404cbf568a04a";
    const apiUrl = `https://api.linkpreview.net/?key=${linkPreviewApiKey}&q=${encodeURIComponent(
        url
    )}`;
    try {
        const response = await fetch(apiUrl);
        const data = await response.json();
        return data.url;
    } catch (error) {
        return null;
    }
};

// eslint-disable-next-line consistent-return
const matchTwoCasesRegex = (link) => {
    const matchesFirstRegex = link.match(firstRegex);
    const matchesSecondRegex = link.match(secondRegex);
    if (matchesFirstRegex) {
        return {
            lat: parseFloat(matchesFirstRegex[1]),
            lng: parseFloat(matchesFirstRegex[2]),
        };
    }
    if (matchesSecondRegex) {
        return {
            lat: parseFloat(matchesSecondRegex[1]),
            lng: parseFloat(matchesSecondRegex[2]),
        };
    }
};

const isLatLong = (str) => {
    const regex = /^([-+]?\d{1,2}(?:\.\d+)?),\s*([-+]?\d{1,3}(?:\.\d+)?)$/;
    return regex.test(str);
};

const extractLatandLong = (address) => {
    const [latitude, longitude] = address.split(",");
    return {
        lat: parseFloat(latitude),
        lng: parseFloat(longitude),
    };
};

export const parseGoogleMapsLink = async (link) => {
    // Shortened Link from web google maps
    if (link.includes("goo.gl/maps")) {
        try {
            const expandedUrl = await expandShortUrl(link);
            return matchTwoCasesRegex(expandedUrl);
        } catch (error) {
            return null;
        }
        // Link from google maps mobile app
    } else if (link.startsWith("https://maps.app.goo.gl")) {
        const expandedUrl = await expandShortUrl(link);
        /* Google map mobile application doesn't contain lat and lang so 
        we match with the address and it also have to regex cases */
        const firstRegex = /\/place\/(.+?)\/data/;
        const secondRegex = /q=([^&]+)/;
        const matchesFirstRegex = expandedUrl.match(firstRegex);
        const matchesSecondRegex = expandedUrl.match(secondRegex);
        if (matchesFirstRegex) {
            const decodedAddress = decodeURIComponent(matchesFirstRegex[1]).replaceAll("+", " ");
            if (isLatLong(decodedAddress)) {
                return extractLatandLong(decodedAddress);
            }
            return decodedAddress;
        }
        if (matchesSecondRegex) {
            const decodedAddress = decodeURIComponent(matchesSecondRegex[1]).replaceAll("+", " ");
            if (isLatLong(decodedAddress)) {
                return extractLatandLong(decodedAddress);
            }
            return decodedAddress;
        }
    } else {
        return matchTwoCasesRegex(link);
    }
    return null;
};

export const isUrl = (str) => {
    // eslint-disable-next-line prefer-regex-literals
    const pattern = new RegExp("^https?:\\/\\/.*$", "i");
    return !!pattern.test(str);
};
